import React from 'react';
import { mediaUrl } from '../services/api';

export function getCategoryIconUrl(category) {
  return (
    category?.icon_url ||
    category?.iconUrl ||
    category?.image_icon_url ||
    ''
  );
}

export default function CategoryIcon({
  category,
  fallback = null,
  alt,
  imageClassName = 'h-10 w-10 object-contain',
}) {
  const iconUrl = getCategoryIconUrl(category);
  const imageUrl = mediaUrl(iconUrl);

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={alt || category?.title || category?.name || ''}
        className={imageClassName}
        loading="lazy"
      />
    );
  }

  return fallback;
}
